import styled from "styled-components";

export const SideNavTabsWrapper = styled.div`
  /* display: flex; */
  max-height: calc(100vh - 93px);
  overflow: scroll;
  @media (max-width: 850px) {
    max-height: calc(100vh - 135px);
  }
`;

export const SubSideNavTabs = styled.div`
  display: flex;
  padding: 5px 7px;
  background: var(--inner-section-bg);
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
  &.web-only-fb {
    display: flex;
  }
  &.mobile-only-fb {
    display: none;
  }
  .message-count {
    position: absolute;
    right: 0;
    top: 0;
    /* padding: 5px; */
    background-color: red;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 0.75rem;
    min-width: 20px;
    line-height: 1;
    padding: 0 6px;
    height: 20px;
    border-radius: 10px;
  }
  .MuiBadge-badge {
    right: 11px;
    top: 11px;
    width: auto;
  }
  .MuiBadge-root {
    flex-shrink: unset;
  }
  @media (max-width: 850px) {
    &.web-only-fb,
    &.web-only-admin-side-nav {
      display: none;
    }
    .Scorecards,
    .site-setup {
      display: none;
    }
    &.mobile-only-fb {
      display: flex;
    }
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(270deg, #000000 45.22%, #494949 106.37%);
    justify-content: space-between;
    z-index: 1;
    padding: 0;
    height: 70px;
    > span {
      flex: 1;
      > span {
        width: 100%;
      }
    }
    .display {
      display: none;
    }
  }
`;

export const ButtonWrapper = styled.div`
  border-radius: 10px;
  border: 1px solid;

  @media (max-width: 850px) {
    border: none;
    border-radius: 0;
    height: 100%;
  }

  /* :hover {
    background: var(--selected-btn-bg);
    font-weight: bold;
    color: var(--theme-text) !important;
  }
  button:hover {
    svg {
      fill: var(--theme-text);
    }
  } */
  button {
    /* display: flex;
    flex-direction: column; */
    width: 60px;
    height: 65px;
    align-items: center;
    /* justify-content: space-evenly; */
    background-color: transparent;
    border: none;
    color: inherit;
    display: grid;
    justify-content: center;
    grid-template-rows: 1fr 22px;
    svg {
      justify-self: center;
    }
    p {
      font-family: "Roboto";
      font-weight: 500;
      font-size: 12px;
      line-height: 150.5%;
      color: inherit;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }

    @media (max-width: 850px) {
      width: 100%;
      height: 100%;
      display: flex;
      p {
        display: none;
      }
    }
  }
`;
